import { COUNTRY_SHORTCODES } from '../../../constants'
import { SupportedCountryCode } from '../../../models/types'

export const countryCodeToTosUrl: Partial<Record<
  SupportedCountryCode,
  string | undefined
>> = {
  [COUNTRY_SHORTCODES.DE]:
    'https://help.doordash.com/dashers/s/terms-of-service-de',
}

export const countryCodeToPrivacyPolicyUrl: Partial<Record<
  SupportedCountryCode,
  string | undefined
>> = {
  [COUNTRY_SHORTCODES.DE]:
    'https://help.doordash.com/dashers/s/privacy-policy-de',
}
